import React, { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { Box, Typography, Button, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CheckoutPage() {
  const { cart } = useContext(CartContext);
  const navigate = useNavigate();

  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  if (!cart.length)
    return (
      <Box p={3}>
        <Typography variant="h5">Your cart is empty 🛒</Typography>
      </Box>
    );

  return (
    <Box p={3}>
      <Typography variant="h4" sx={{ mb: 3 }}>Checkout</Typography>

      <Card sx={{ p: 3, mb: 3 }}>
        {cart.map((item) => (
          <Typography key={item.id} sx={{ mb: 1 }}>
            {item.title} × {item.qty} = ₹{item.qty * item.price}
          </Typography>
        ))}

        <Typography variant="h6" sx={{ mt: 2 }}>
          Total: ₹{total}
        </Typography>
      </Card>

      <Button
        variant="contained"
        sx={{ backgroundColor: "#ff9900" }}
        onClick={() => navigate("/payment", { state: { total } })}
      >
        Proceed to Payment →
      </Button>
    </Box>
  );
}
